module.exports = __webpack_public_path__ + "img/bg.02c56258.png";